import smh from './smh';
const QueryTaskInterval = 5000;
/**
 * @description 查询单个异步任务直到任务结束 (异步任务查询间隔 5s)
 * @export
 */
export function queryAsyncTask(_taskId: string | number, callback?: Function): Promise<any> {
  const taskId = _taskId.toString();
  const query = async () => {
    let result;
    try {
      const res = await smh.userAPI.queryTask({
        taskIdList: taskId,
      });
      [result] = res.data;
    } catch (e) {
      // 偶现查询出错，认为任务没有结束，下次轮询重试
      result = {
        status: 202,
        remaining: -1,
      };
    }
    return result;
  };

  // 异步任务结束标志
  /**
   * 200: 任务成功完成且有返回结果，返回结果在 result 字段中
   * 202: 任务进行中
   * 204: 任务成功完成且无返回结果
   * 207: 任务部分失败，有返回结果
   * 499: 用户取消
   * 500: 任务执行失败；
   */
  const isTaskFinished = (res: { status: number; remaining: number }) => {
    let statusCode = res.status;
    if (Math.round(statusCode / 100) === 5) statusCode = 500;
    if (Math.round(statusCode / 100) === 4) statusCode = 400;
    if ([200, 204, 207, 400, 500].includes(statusCode) || res.remaining === 0) {
      return true;
    }
    return false;
  };
  let taskTimer = 0;
  return new Promise(resolve => {
    const queryFn = async () => {
      const res = await query();
      if (isTaskFinished(res)) {
        resolve(res);
        callback && callback(res);
      } else {
        taskTimer && window.clearTimeout(taskTimer);
        if (res.status === 202) {
          taskTimer = window.setTimeout(() => {
            queryFn();
          }, QueryTaskInterval);
        }
      }
    };
    queryFn();
  });
}
